import { Component, createRef } from "react"
import { createPortal } from "react-dom"

/* Components */
import { Icon } from "../../components"

/* Shared */
import { toneOf } from "../category/shared"


/* The width of the window — it is kept inside the screen by it */
const WIDTH = 300


/* Widget Category Picker — a small window with the search which opens right under the button
   pressed. It lives in the body of the document: a window of a modal is transformed, and a fixed
   box inside it would be placed by the window instead of the screen. One picker serves the lines of the list, the bulk bar and the filter.
   It is opened by the reference: this._picker.current.open(element, { selected, onSelect, all, none }) */
class CategoryPicker extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            search: "",
            top: 0,
            left: 0,
            selected: null,

            /* "Все категории" — for the filter, "Без категории" — to take the category away */
            all: false,
            none: false,
            title: ""
        }

        this._box = createRef()
        this.onSelect = null
    }

    componentDidMount = () => {
        document.addEventListener("mousedown", this.outside)
        window.addEventListener("resize", this.close)
    }

    componentWillUnmount = () => {
        document.removeEventListener("mousedown", this.outside)
        window.removeEventListener("resize", this.close)
    }

    /* Open under the element — or over it, when there is no room left below */
    open = (element, options = {}) => {

        const rect = element.getBoundingClientRect()
        const height = 380

        const left = Math.max(12, Math.min(rect.left, window.innerWidth - WIDTH - 12))
        const below = rect.bottom + 8
        const top = below + height > window.innerHeight ? Math.max(12, rect.top - height - 8) : below

        this.onSelect = options.onSelect ? options.onSelect : null

        this.setState({
            visible: true,
            search: "",
            top,
            left,
            selected: options.selected === undefined ? null : options.selected,
            all: Boolean(options.all),
            none: Boolean(options.none),
            title: options.title ? options.title : "Категория"
        })
    }

    close = () => {
        if (this.state.visible) {
            this.setState({ visible: false })
        }
    }

    /* A press anywhere outside closes the window */
    outside = event => {
        if (this.state.visible && this._box.current && !this._box.current.contains(event.target)) {
            this.close()
        }
    }

    choose = value => {

        const onSelect = this.onSelect

        this.setState({ visible: false })

        if (onSelect) {
            onSelect(value)
        }
    }

    /* Enter takes the first category which is left after the search */
    submit = (event, groups) => {

        event.preventDefault()

        if (groups.length > 0 && groups[0].items.length > 0) {
            this.choose(groups[0].items[0].id)
        }
    }

    render = () => {

        /* Fields */
        const { visible, search, top, left, selected, all, none, title } = this.state
        const { categories } = this.props

        if (!visible) {
            return null
        }

        const query = search.trim().toLowerCase()

        /* The categories by their groups, in the order of the home screen */
        const groups = []

        for (const category of categories) {

            if (query.length > 0 && !`${category.name}`.toLowerCase().includes(query) && !`${category.typeName}`.toLowerCase().includes(query)) {
                continue
            }

            let group = groups.find(item => item.id === category.typeID)

            if (!group) {
                group = { id: category.typeID, name: category.typeName ? category.typeName : "Без группы", items: [] }
                groups.push(group)
            }

            group.items.push(category)
        }

        return createPortal(
            <div ref={this._box} className="category-picker" style={{ top, left, width: WIDTH }}>

                <div className="category-picker-title">{title}</div>

                <form onSubmit={event => this.submit(event, groups)} className="category-picker-search">
                    <Icon name="search" size={15} />
                    <input autoFocus placeholder="Найти категорию" value={search} onChange={event => this.setState({ search: event.target.value })} onKeyDown={event => { if (event.key === "Escape") this.close() }} />
                </form>

                <div className="category-picker-list">

                    {query.length === 0 && all &&
                        <div onClick={() => this.choose("all")} className={`category-picker-item special ${selected === "all" ? "active" : ""}`}>
                            <Icon name="category" size={15} width={2} />
                            Все категории
                        </div>
                    }

                    {query.length === 0 && none &&
                        <div onClick={() => this.choose("none")} className={`category-picker-item special warning ${selected === "none" ? "active" : ""}`}>
                            <Icon name="alert" size={15} width={2} />
                            Без категории
                        </div>
                    }

                    {groups.map(group => {

                        const tone = toneOf(group.id)

                        return (
                            <div key={`${group.id}`} className="category-picker-group" style={{ "--tone": tone.accent, "--tone-soft": tone.soft }}>
                                <div className="category-picker-group-name"><i />{group.name}</div>
                                {group.items.map(category =>
                                    <div
                                        key={`${category.id}`}
                                        onClick={() => this.choose(category.id)}
                                        className={`category-picker-item ${parseInt(selected) === parseInt(category.id) ? "active" : ""}`}
                                    >
                                        {category.name}
                                        {parseInt(category.visible) !== 1 && <Icon name="eyeOff" size={12} width={2} />}
                                        {parseInt(selected) === parseInt(category.id) && <Icon name="check" size={13} width={2.6} />}
                                    </div>
                                )}
                            </div>
                        )
                    })}

                    {groups.length === 0 && <div className="category-picker-empty">Ничего не нашлось</div>}

                </div>

            </div>,
            document.body
        )
    }
}

export default CategoryPicker
